// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39gCS","name":"styles_name__-uyR8","phone":"styles_phone__1FHQY"};